import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import withPageEntry from '../../withPageEntry';
import TeamContent from '../../Components/TeamContent';

function Team(props) {
  const [locale, setLocale] = useOutlet('locale');
  const lang = locale.lang;
  const isJapanPage = props.location.pathname.indexOf('japan') > -1;
  const isEnglishPage = props.location.pathname.indexOf('eng') > -1;

  React.useEffect(() => {
    if (isJapanPage && lang !== 'jp') {
      setLocale({lang: 'jp'});
    } else if (isEnglishPage && lang !== 'en') {
      setLocale({lang: 'en'});
    }
  }, [isJapanPage, isEnglishPage, lang, setLocale]);

  return (
    <Wrapper>
      <TeamContent {...props} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: var(--topNavBarHeight) auto 0px;
  max-width: var(--contentMaxWidth);
  width: 100%;
  min-height: 100vh;
  padding: 40px 20px;
`;

export default withPageEntry(Team);
